export var HIDE_OPEN_IN_MOBILE = 'HIDE_OPEN_IN_MOBILE';
